export enum StatusType {
  all = 'All Statuses',
  published = 'Published',
  unpublished = 'Unpublished',
}